import { ISplMessage } from './index';

export class ISplMessages {
    messages: ISplMessage[];
}
